// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1WQVm","col":"styles_col__37Rwx","fulfillmentStatus":"styles_fulfillmentStatus__3kuYC","emailCol":"styles_emailCol__1G3WV"};